import { createTRPCReact } from "@trpc/react-query";

import type { AppTrpcRouter } from "../../../server/src/router/trpcRouter";

export { trpc };

const trpc = createTRPCReact<AppTrpcRouter>();
